import React from 'react';
import { TabFilesDatagrid } from '../../../components/fileManager/TabFilesDatagrid';
import { PageContentWrapper } from '../../../layouts/contentWrapper/PageContentWrapper';
import { ITab } from '../../Assets/AssetsEdit';

interface Props extends ITab {
  id: string;
  assetId: number;
  assetName: string;
  mutateAttachmentCount?: () => void;
}

export const TaskFilesTab = ({ id, assetId, assetName, mutateAttachmentCount }: Props) => {
  return (
    <PageContentWrapper noLoadingModal noContentBlock noDxCard>
      <TabFilesDatagrid
        id={id as unknown as number}
        entityName="Task"
        isReadonly={false}
        onFileCountChange={mutateAttachmentCount ? mutateAttachmentCount : undefined}
        mainEntity="task"
        assetId={assetId}
        assetName={assetName}
      />
    </PageContentWrapper>
  );
};
